import { css } from '@lastbrand/web-ui-styled-system/css'

// Layout only — the inter-option gap is applied separately (optionListGapClass / optionListGapPdpClass)
// so PDP/QATC can swap row vs column gaps. Every consumer must pair this with a gap class.
export const optionListWrapperClass = css({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
})

export const optionListGapClass = css({ gap: 'space-8' })

// COLOR branch only. Unlike the flat non-color row, the swatches live inside their own
// `SelectColorGroup` Root, so `+N` is a sibling of that whole block rather than a peer of the
// swatches: once the Root claims the full line, a wrapping outer row orphans `+N` onto the next
// one (STRFRNT-16423). The mini PDP sizes its optionLimit to the measured row width so nothing
// needs to wrap; this `nowrap` + shrinkable-Root pair is the structural guarantee that `+N`
// stays on the swatch row even if the measurement is ever off. No flexGrow on the Root — `+N`
// sits right after the last swatch (legacy placement), not at the row's far edge.
// Unbounded COLOR rows (full-PDP buy box, social section) also render through this pair but
// pass no optionLimit/`+N`; it's inert there — the extended Root wraps its swatches internally,
// so `nowrap` + `minWidth: 0` renders identically to the old wrapping row.
export const colorOptionListWrapperClass = css({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
})

export const colorGroupShrinkClass = css({
  flexShrink: 1,
  minWidth: 0,
})
// paddingTop was dropped: the header→options offset it produced is now owned by ProductPropertyDS's
// content wrapper (`marginTop: space-12` in product-property-ds.styles.ts), which every
// `renderProductOption` (isPDP: true) caller now renders through.
export const optionListGapPdpClass = css({ columnGap: 'space-8', rowGap: 'space-16' })

export const optionWrapperClass = css({
  display: 'flex',
})

export const packOptionWrapperClass = css({
  // full width on mobile, auto from `lg` up.
  width: { base: '100%', lg: 'auto' },
})

export const engravingOptionWrapperClass = css({
  flexGrow: 1,
})

export const optionNameClass = css({
  marginTop: 'space-2',
})

export const excessElementsClass = css({
  display: 'flex',
  alignItems: 'center',
  textStyle: 'body-14',
  flexShrink: 0,
})

// Pointer cursor only when the +N control is actually clickable (a handler is wired).
export const excessElementsInteractiveClass = css({
  cursor: 'pointer',
})
